import React from 'react';

import whyScoresMatterCard from '@backrs_ui/grow-ui/src/assets/images/standardized-tests-guide/why-scores-matter-card.png';
import { GUIDE_TEXT_MAX_WIDTH } from '@backrs_ui/grow-ui/src/components/GuidePage';
import type { StandardizedTestsWhyScoresMatter } from '@backrs_ui/grow-ui/src/pages/StandardizedTestsGuide/content/types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type WhyScoresMatterSectionProps = Readonly<{
  content: StandardizedTestsWhyScoresMatter;
}>;

export const WhyScoresMatterSection: React.FC<WhyScoresMatterSectionProps> = ({ content }) => (
  <Box sx={containerSx}>
    <Box sx={textColumnSx}>
      <Typography variant="text-md-regular" sx={introSx}>
        {content.intro}
      </Typography>

      {content.items.map((item) => (
        <Box key={item.label} sx={itemSx}>
          <Typography variant="text-md-semibold" sx={labelSx}>
            {item.label}
          </Typography>
          <Typography variant="text-md-regular" sx={descriptionSx}>
            {item.description}
          </Typography>
        </Box>
      ))}
    </Box>

    <Box sx={cardColumnSx}>
      <Box component="img" src={whyScoresMatterCard} alt={content.conclusion} sx={cardImgSx} />
    </Box>
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
  '@container (min-width: 720px)': {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
});

const textColumnSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
  flex: 1,
  minWidth: 0,
  maxWidth: '540px',
});

const introSx: SxProps<Theme> = {
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
};

const itemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
});

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const descriptionSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

const cardColumnSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
  width: '100%',
  '@container (min-width: 720px)': {
    width: '320px',
  },
};

const cardImgSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  maxWidth: '320px',
  height: 'auto',
  borderRadius: backrs.radius['radius-xl'],
  display: 'block',
});
